import { createAction, props } from "@ngrx/store";
import { LetterOfAuthorizationResponse } from "../../create-request/models/pdf/LetterOfAuthorizationResponse";

export const editClicked = createAction(
    '[Create Standing Authorization - Review Page] Edit clicked'
);

export const editCompleted = createAction(
    '[Create Standing Authorization - Review Page] Edit completed'
)

export const cancelClicked = createAction(
    '[Create Standing Authorization - Review Page] Cancel clicked'
);

export const submitClicked = createAction(
    '[Create Standing Authorization - Review Page] Submit clicked'
);

export const loadConfirmationPage = createAction(
    '[Create Standing Authorization - Review Page] Load the confirmation page'
);

export const clearAttentionMessage = createAction(
    '[Create Standing Authorization - Review Page] Clear Attention Messages'
);

export const generateAuthorizationForm = createAction(
    '[Create Standing Authorization - Review Page] Generate authorization form'
);

export const generateAuthorizationFormSuccessful = createAction(
    '[Create Standing Authorization - Review Page]  Generate authorization form successful',
    props<{ response: LetterOfAuthorizationResponse }>()
);

export const generateAuthorizationFormFail = createAction(
    '[Create Standing Authorization - Review Page] Error generating form',
    props<{ errorMsg: string }>()
);

export const clientAwaitingAllianceUsed = createAction(
    '[Create Standing Authorization - Review Page] Send email to eauth client with Awaiting Alliance setup status',
    props<{ accountId: string, customerId: string, emailAddress: string }>()
);

export const loadEmptyConfirmationPage = createAction(
    '[Create Standing Authorization - Review Page] Create PDF clicked to generate empty confirmation page'
);
